import { useState } from "react";
import Pagination from "../components/common/Pagination/Pagination";

const usePagination = ({ totalItemsCount, itemsPerPage = 5 }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(itemsPerPage);

  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalItemsCount) {
      setPage(newPage);
    }
  };

  const PaginationComponent = (
    <Pagination
      page={page}
      handlePageChange={handlePageChange}
      totalPageCount={Math.ceil(totalItemsCount / itemsPerPage)}
    />
  );

  return { page, setPage, pageSize, PaginationComponent };
};

export default usePagination;
